var _effectorFileName = "/builds/gmini/front-ui-kit/src/Tooltip/Tooltip.styled.tsx";
import { Tooltip as TooltipBase } from '@mui/material';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
export const TooltipStyled = styled(({
  className,
  ...props
}) => /*#__PURE__*/_jsx(TooltipBase, { ...props,
  classes: {
    popper: className
  }
}))(({
  zIndex,
  noMaxWidth,
  style
}) => ({
  '&&': {
    zIndex
  },
  '&& .MuiTooltip-tooltip': {
    backgroundColor: 'rgba(63, 63, 63, 0.95)',
    color: '#FFFFFF',
    fontWeight: 400,
    fontSize: 12,
    lineHeight: '20px',
    borderRadius: '4px',
    fontFamily: 'Roboto, sans-serif',
    padding: '1px 6px',
    letterSpacing: 'normal',
    margin: '3px',
    maxWidth: noMaxWidth ? 'none' : 300,
    ...style
  }
}));
export const TooltipContent = styled.div`
  display: flex;
  width: ${props => props.fillAvailable ? '-webkit-fill-available' : 'auto'};
`;